"use strict";

/******************
** ANIMATION HEADER **
*******************/
var landing = document.querySelector('#js-landing');
setTimeout(function () {
  landing.classList.remove('not-init');
}, 100);
/*****************************
** TWEENMAX - ANIMATION SVG **
https://greensock.com/tweenmax/
******************************/

function animateFromTo(el, from, to, duration, delay) {
  TweenMax.to(el, 0, {
    css: from
  });
  TweenMax.to(el, duration, {
    css: to,
    ease: Power4.easeOut,
    delay: delay
  });
}

function animateLandingStagger(el, config) {
  var target = document.querySelectorAll(el); //remove all style

  TweenMax.to(target, 0, {
    css: config.from
  }); //animate list with delay

  TweenMax.staggerTo(target, config.duration, {
    css: config.to,
    ease: Power4.easeOut,
    delay: config.delayBeforeAnimate
  }, config.delay);
}
/*******************************
**** AOS - SCROLL ANIMATIONS ***
https://michalsnik.github.io/aos/
********************************/


AOS.init({
  anchorPlacement: 'top-top',
  duration: 800,
  delay: 50
});